<template>
  <div id="app">
    <Header />
      <!-- eslint-disable-next-line max-len -->
      <b-navbar class="navbar navbar-expand-sm navbar-light bg-white border-bottom shadow-sm d-block d-sm-block d-md-none d-lg-none d-xl-none"
          toggleable="lg">
        <div class="container">
          <router-link to="/" class="navbar-brand mr-2 pt-0">
            <img :src="logo" height="30" alt="logo">
          </router-link>
          <template v-if="loggedIn" class="ml-auto my-1">
            <b-button size='sm' @click="signOut">Sign Out</b-button>
          </template>
        </div>
      </b-navbar>
      <template v-if="$route.params.project_id">
      <!-- eslint-disable-next-line max-len -->
        <b-navbar class="navbar navbar-expand-sm navbar-light bg-white border-bottom shadow-sm d-block d-sm-block d-md-none d-lg-none d-xl-none primary-mobile-nav"
          toggleable="lg"
          sticky>
          <div class="container">
            <h5>{{ currentProjectName }}</h5>
          </div>
        </b-navbar>
        <!-- eslint-disable-next-line max-len -->
        <b-navbar class="navbar navbar-expand-sm navbar-light bg-white border-bottom shadow-sm mb-3 d-block d-sm-block d-md-none d-lg-none d-xl-none secondary-nav"
            toggleable="lg"
            sticky>
          <div class="container">
            <b-navbar-brand>
              <h5>{{ projectContext() }}</h5>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse1"></b-navbar-toggle>
            <b-collapse id="nav-collapse1" is-nav>
              <ProjectNavigation :isDesktop="false"/>
            </b-collapse>
          </div>
        </b-navbar>
      </template>
      <!-- eslint-disable-next-line max-len -->
      <b-navbar class="navbar navbar-expand-sm navbar-light bg-white border-bottom shadow-sm d-md-block d-lg-block d-xl-block d-none d-sm-none"
                :class="{ 'mb-3': !($route.params.project_id) }"
                toggleable="lg"
                sticky>
        <div class="container">
          <b-navbar-brand to="/" class="navbar-brand mr-2 pt-0">
            <img :src="logo" height="30" alt="logo">
          </b-navbar-brand>
          <ul class="navbar-nav">
            <li class='nav-item mx-2 my-1'>
              <router-link to="/" class="nav-link py-1">Home</router-link>
            </li>
            <li class="nav-item mx-2 my-1">
              <router-link to="/search" class="nav-link py-1">Advanced Search</router-link>
            </li>
            <li class="nav-item mx-2 my-1">
              <a href="https://virginiaoutdoors.sharepoint.com/sites/TT" target="_blank" rel="noopener noreferrer" class="nav-link py-1">
                Help
              </a>
            </li>
            <li v-if="loggedIn" class="ml-2 my-1">
              <b-button size='sm' @click="signOut">Sign Out</b-button>
            </li>
          </ul>
        </div>
      </b-navbar>
      <template v-if="$route.params.project_id">
        <!-- eslint-disable-next-line max-len -->
        <b-navbar class="navbar navbar-expand-sm navbar-light bg-white border-bottom shadow-sm mb-3 d-md-block d-lg-block d-xl-block d-none d-sm-none secondary-nav"
                  toggleable="lg"
                  sticky>
          <div class="container">
            <h5>{{ currentProjectName }}</h5>
            <ProjectNavigation :isDesktop="true"/>
          </div>
        </b-navbar>
        <div class="container">
          <router-view/>
        </div>
      </template>
      <div v-else-if="$router.currentRoute.name === 'contact'" class="container">
        <router-view/>
      </div>
      <div v-else class="desktop-container">
        <router-view/>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/Header.vue';
import ProjectNavigation from '@/components/common/ProjectNavigation.vue';
import auth from './auth';

export default {
  components: {
    Header,
    ProjectNavigation,
  },
  data() {
    return {
      logo: null,
    };
  },
  created() {
    this.getLogo();
  },
  watch: {
    $route(to) {
      if (to.params.project_id && this.currentProject && parseInt(to.params.project_id, 10) !== this.currentProject.id) {
        this.$store.dispatch('CurrentProject/fetch', { projectId: parseInt(to.params.project_id, 10) });
      }
    },
  },
  computed: {
    ...mapState('CurrentProject', {
      currentProject: state => state.currentProject,
    }),
    loggedIn() {
      return this.$store.getters['User/getCurrentUser'].name;
    },
    currentProjectName() {
      if (!this.currentProject) {
        return '';
      }
      return `Project ${this.currentProject.id}: ${this.currentProject.name}`;
    },
  },
  methods: {
    signOut() {
      auth.initialize(this.$store).then(() => auth.clientApplication.logout());
    },
    projectContext() {
      const projectRoute = '/project/';
      if (this.$route.fullPath.indexOf(projectRoute) >= 0) {
        let contextName = this.$route.fullPath.substring(
          this.$route.fullPath.indexOf('/', projectRoute.length) + 1,
          this.$route.fullPath.lastIndexOf('/'),
        );
        // The context name must have more than nothing or just a slash
        if (contextName.length > 1) {
          contextName = contextName.charAt(0).toUpperCase() + contextName.slice(1);
          return contextName;
        }
      }
      return '';
    },
    getLogo() {
      this.$store.dispatch('fetchConfiguration')
        .then(() => { this.logo = this.$store.state.Config.config.appLogo; });
    },
  },
};
</script>
